import { gsap, ScrollTrigger } from './gsap';

const header = () => {
  const state = {
    isOpen: false
  };

  const body = document.querySelector('body');
  const headerElement = document.querySelector('.header');
  const nav = headerElement.querySelector('nav');
  const navBurger = headerElement.querySelector('.nav-btn');
  const navListItems = headerElement.querySelectorAll('.nav-list li');
  const w = window.innerWidth;
  const h = window.innerHeight;
  const size = Math.sqrt(w * w + h * h) * 2;

  gsap.set(nav, {
    '--nav-width': size + 'px',
    '--nav-height': size + 'px',
    '--nav-scale': 0,
  });

  const showHeader = gsap.from(headerElement, {
    yPercent: -110,
    paused: true,
    duration: 0.2
  }).progress(1);

  ScrollTrigger.create({
    start: 'top top',
    end: 99999,
    onUpdate: (self) => {
      if (self.direction === -1) {
        showHeader.play();
      } else {
        showHeader.reverse();
      }
    }
  });

  if (headerElement.classList.contains('blue')) {
    ScrollTrigger.create({
      start: 'bottom top',
      trigger: 'main .blue',
      onEnter: () => {
        headerElement.classList.remove('blue');
      },
      onEnterBack: () => {
        headerElement.classList.add('blue');
      }
    });
  }

  const mobileNavTimeline = gsap.timeline({
    paused: true,
    reversed: true,
    onReverseComplete: () => {
      headerElement.classList.remove('nav-open');
    }
  }).to(nav, {
    duration: 1.5,
    '--nav-scale': 2,
    display: 'block',
  })
    .from(navListItems, {
      autoAlpha: 0,
      x: 10,
      stagger: {
        amount: 0.4
      }
    }, 0.4);

  const showNavigation = () => {
    state.isOpen = true;
    headerElement.classList.add('nav-open');
    body.classList.add('overflow-hidden-mobile');
    mobileNavTimeline.play();
  };

  const hideNavigation = () => {
    state.isOpen = false;
    mobileNavTimeline.timeScale(1.2).reverse();
    body.classList.remove('overflow-hidden-mobile');
  };

  const toggleNavigation = () => {
    if (state.isOpen) {
      hideNavigation();
    } else {
      showNavigation();
    }
  };

  navBurger.addEventListener('click', () => {
    toggleNavigation();
  });
};

export default header;
